export const MODE_CAMERA = 'camera';
export const MODE_LIVE = 'live';
export const EDEVICETYPE = {
  CAMERA: 'camera',
  GATEWAY: 'gateway',
  GPS: 'gps_location',
  SPEAKER: 'speaker_sip',
};

export const CAMERA_TYPE = {
  BODY_WARM_AXIS: 'body_warm_axis',
  MILESTONE: 'milestone'
}

export const CAMERA_BRAND = {
  'FA1005': 'FA1005',
  'HIKVISION-DS-K1T342MFWX': 'HIKVISION-DS-K1T342MFWX'
}


export const REPORT_TYPE = {
  REPORT_ACCOUNT: 'report_account',
  REPORT_STORAGE: 'report_storage',
  REPORT_GATEWAY: 'report_gateway',
  REPORT_GATEWAY_INFO: 'report_gateway_info',
};
